import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LogService, ServiceRouter } from '@pershing/pershing-core';
import { NxiWidgetParamsServiceDefinition } from './NXI-WidgetParams-service-definition';
import { Observable } from 'rxjs';
import { PershingTranslationService } from '@pershing/pershing-core';
import { Params } from '@angular/router';

@Injectable()
export class NxiWidgetParamsService {
    private serviceUrl: string;
    constructor(private http: HttpClient, private logService: LogService, private serviceRouter: ServiceRouter, private translationService: PershingTranslationService) {
        this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
        this.serviceUrl = this.serviceRouter.getServiceRouteURL(NxiWidgetParamsServiceDefinition.getInstance());
        // this.serviceUrl = 'http://investor-qa-pershing.test.bnymellon.net:8090/dev-netxinvestor-rest-service-app/services/netxclient.rest-service';
    }

    public getWidgetParams(acctresp: string, url: string): Observable<any> {
        console.log('Getting NXI widget Params for ', url);
        const options = {
            headers: new HttpHeaders().append('Account', acctresp)
        };
        return this.http.get(this.serviceUrl + '/commonrest/' + 'urn:id:headers.Account' + '/' + url, options);
    }

    public getWidgetParamsForMixin(url: string): Observable<any> {
        let timeNow = Date.now();
        this.logService.info('NxiWidgetService : getting Params');
        console.log(this.serviceUrl + '/commonrest/' + url);
        return this.http.get(this.serviceUrl + '/commonrest/' + url + '?time=' + timeNow);
    }

    public getWidgetParam(url: string): Observable<any> {
        this.logService.info('NxiWidgetService : getting Params');
        console.log(this.serviceUrl + url);
        return this.http.get(this.serviceUrl + url);
    }

    public getTranslatedMessage(message: string): string {
        this.translationService.get(message).subscribe(
            res => {
                return res;
            }
        );
        return null;
    }

    public renderAccountStatus(queryParams: Params): Observable<any> {
        let timeNow = Date.now();
        let params = this.convertQueryParamToObj(queryParams);
        return this.http.get(this.serviceUrl + '/accountopening/accountstatus/getmodel' + '?time=' + timeNow, { params: params });
    }
    private convertQueryParamToObj(queryParams: Params): any {
        let param = {};
        if (queryParams === null) {
            return param;
        }
        for (let query in queryParams) {
            if (queryParams.hasOwnProperty(query)) {
                param[query] = queryParams[query];
            }
        }
        return param;
    }

}
